import { definePersistenceEntry, type UiModule } from '@krp/client-runtime'

import { decodeSnapshots, ownSaleSnapshotsRestored } from './features/snapshot/model/snapshotSlice'
import { ownUiReducer, type OwnUiState } from './state'
import { ownWindows } from './windows/registerWindows'

/** Сколько живёт снимок: дольше смены кассы ждать исход незачем — дальше правду говорит журнал агента. */
const SNAPSHOT_TTL_MS = 12 * 60 * 60 * 1000

/**
 * Модуль пакета для composition: окно РМК источника «Собственная». Endpoints пакет регистрирует сам
 * (`baseApi.injectEndpoints`, имена `own*`, rid в аргументах и тегах).
 */
export function createOwnUiModule(): UiModule<OwnUiState> {
  return {
    id: 'own',
    reducer: ownUiReducer,
    slices: [
      {
        name: 'sale',
        lifetime: 'screen',
        reason: 'корзина и этап продажи этого окна: после F5 или закрытия вкладки корзину возвращает снимок начатой оплаты, а не слайс; в хранилище браузера не пишется',
      },
      {
        name: 'operation',
        lifetime: 'screen',
        reason: 'открытые формы «Подробнее», отказ агента и заметки после продажи: после F5 правду об операции говорит журнал агента',
      },
      {
        name: 'paymentAttempt',
        lifetime: 'screen',
        reason: 'попытка оплаты этого окна (RP-PAY-ONE): ключ окна оплаты, «Свернуть», «Закрыть» и «команда не ушла»; ход и итог говорит агент, после F5 — его журнал',
      },
      {
        name: 'cashier',
        lifetime: 'screen',
        reason: 'выбранный кассир и подтверждение PIN-ом (≤ 10 минут): только в памяти вкладки, без PIN и токена; после F5 PIN вводится заново',
      },
      {
        name: 'saleSnapshots',
        lifetime: 'session',
        reason: 'снимок строк чека на начало оплаты: F5 не теряет, что именно пробивалось; повтор и восстановление берут его, а не текущую карточку',
      },
    ],
    windows: ownWindows,
    persistence: [
      definePersistenceEntry({
        key: 'own.sale-snapshots',
        slice: 'saleSnapshots',
        lifetime: 'session',
        scope: 'user',
        version: 1,
        ttlMs: SNAPSHOT_TTL_MS,
        pick: (state: OwnUiState) => state.saleSnapshots.byResource,
        decode: decodeSnapshots,
        restore: ownSaleSnapshotsRestored,
      }),
    ],
    listeners: [],
  }
}
